import React from "react";

const Title = ({ title, className = "" }) => {
  return (
    <h2 className={`text-2xl font-bold text-black font-playfair ${className}`}>
      {title}
    </h2>
  );
};

export default Title;
